<template>
  <div />
</template>

<script>
export default {
  data () {
    return {
      isOpen: false
    }
  },
  methods: {
    asyncMethod () {
    }
  }

}
</script>

<style scoped>

</style>
